import { AutogenLayoutStandardCodeVersionLookup } from "./autogen/AutogenLayoutStandardCodeVersionLookup";

export class StandardCodeVersionLookup extends AutogenLayoutStandardCodeVersionLookup {
}
